import PropTypes from 'prop-types';
import React from 'react';

import { IconFont, Navbar } from 'fr-shared/components';

import { Button } from 'portal/components';

import styles from './NavbarInsights.module.css';

const LogoExtra = <div className={styles.LogoExtra}>Insights Report</div>;

const NavbarInsights = ({ children, customer, customerContact, part }) => {
  const emailReportTo = `mailto:${customerContact.email}?subject=${encodeURIComponent(
    `Your ${part.name} Feasibility Report`
  )}&body=${encodeURIComponent(window.location.href)}`;

  return (
    <>
      <Navbar
        container="sm"
        color="dark"
        className={`${styles.Navbar} sticky-top`}
        logoUrl={'/'}
        showLogoExtra={LogoExtra}
        showEnvironment={false}
      >
        <Button size="sm" to={{ pathname: emailReportTo }} openNewWindow>
          <IconFont name="email" right={true} /> Email Report
        </Button>
      </Navbar>

      <div className="container-sm flex align-items-center py-3">
        <div className="text-muted">
          {customerContact.name}, {customer.name}
        </div>

        {children}
      </div>
    </>
  );
};

NavbarInsights.propTypes = {
  children: PropTypes.node,
  customer: PropTypes.object,
  customerContact: PropTypes.object,
  part: PropTypes.object,
};

export default NavbarInsights;
